import JourneyWithNextSchedule from '../../JourneyWithNextSchedule';
import { JourneyActionPayload, getCurrentSchedule } from '..';
import { Button as ButtonSmall } from '../style';
import { useState } from 'react';
import Modal from '../../../pages/Journey/ContentExams/Modal';
import { RootState } from '../../../../store';
import { useSelector } from 'react-redux';
import { ISchedules } from '../../../../services/journey.service';

export const ReportAvailableSmall = ({ journey }: JourneyActionPayload) => {
  const [open, setOpen] = useState(false);
  const {
    journey: { files }
  } = useSelector((state: RootState) => state);

  const handleOpen = () => {
    setOpen(!open);
  };
  const currentSchedule = getCurrentSchedule(journey);
  return (
    <>
      <JourneyWithNextSchedule
        journey={journey}
        schedule={currentSchedule as ISchedules}
        actionButton={
          <ButtonSmall variant="contained" onClick={() => handleOpen()}>
            Ver relatório
          </ButtonSmall>
        }
      />
      <Modal
        openCloseController={open}
        onCloseHandler={() => {
          handleOpen();
        }}
        infoType={'REPORTS'}
        dataFiles={files}
      />
    </>
  );
};
